import React from 'react';

import { useMediaQuery } from '@mui/material';

import SearchBar from 'main/components/SearchBar';
import DrawerMenuButton from 'pages/layout/components/DrawerMenuButton';
import Logo from 'pages/layout/components/Logo';
import UpgradeLicenseButton from 'pages/layout/components/UpgradeLicenseButton';

import useStyles from './styles';

const Header = () => {
    const { classes } = useStyles();
    const shouldShowSearchBar = useMediaQuery('(min-width: 480px)', { defaultMatches: true });
    const shouldMenuButton = useMediaQuery('(max-width: 480px)', { defaultMatches: true });

    return (
        <div className={classes.container}>
            <div className={classes.logoBox}>
                <Logo />
            </div>
            {shouldShowSearchBar && <SearchBar className={classes.searchBarRoot} />}
            <div className={classes.buttons}>
                <UpgradeLicenseButton />
                {shouldMenuButton && <DrawerMenuButton className={classes.menuButton} />}
            </div>
        </div>
    );
};

export default Header;
